import ContentLoader from 'react-content-loader';
import React from 'react';
import {
  Alert,
  Input,
  FormLabel,
  BackgroundPaper,
  FilledButton,
  SubtleButton,
  TextButton,
} from '@ds/react-components';
import { styled, Typography } from '@material-ui/core';

export const BusinessAccountName = styled((props) => (
  <Typography variant={'h3'} {...props} />
))(({ theme }) => ({
  marginTop: '18px',
  color: theme.palette.common.black,
}));

export const Paper = styled(BackgroundPaper)({
  maxWidth: '910px',
  minHeight: '50px',
  marginTop: '18px',
  height: 'fit-content',
});

export const PaperHeader = styled('div')(({ theme }) => ({
  padding: '18px 32px',
  borderBottom: `1px solid ${theme.palette.common.athensGray}`,
  color: theme.palette.common.black,
  fontWeight: 'normal',
  display: 'flex',
  flexDirection: 'row',
}));

export const PaperBody = styled('div')({
  padding: '18px 32px',
  display: 'flex',
  flexDirection: 'column',
});

export const PaperHeaderText = styled((props) => (
  <Typography variant={'h4'} {...props} />
))({
  fontWeight: 'bold',
});

export const LoaderHeader = (props) => (
  <ContentLoader
    speed={2}
    width={140}
    height={20}
    viewBox="0 0 140 20"
    style={{ width: '140px', height: '20px' }}
    {...props}>
    <rect x="0" y="1" rx="6" ry="6" width="140" height="20" />
  </ContentLoader>
);

export const FormContainer = styled('div')({});

export const InfoAlert = styled(Alert)({
  marginTop: '18px',
  maxWidth: '910px',
});

export const FormInput = styled(Input)({
  maxWidth: '380px',
});

export const PaperBodyOverload = styled(({ loading, ...other }) => (
  <PaperBody {...other} />
))(({ loading }) => ({
  padding: '16px 32px 16px 32px',
  opacity: loading ? 0.5 : 1,
  pointerEvents: loading ? 'none' : 'initial',
}));

export const ActionButtonContainer = styled('div')({
  display: 'flex',
  marginTop: '18px',
});

export const CancelButton = styled(SubtleButton)({
  marginLeft: '16px',
});

export const ConfirmSubmissionButton = styled(FilledButton)({
  fontWeight: 'bold',
});

export const InputWrapper = styled('div')({
  margin: '16px 0',
});

export const LabelContainer = styled('div')({
  marginBottom: '8px',
});

export const InputLabel = styled(FormLabel)({
  marginBottom: 0,
});

export const ErrorMessage = styled('label')({
  color: 'rgb(176, 0, 32)',
});

export const ClearAllButton = styled(TextButton)({
  flex: '1',
  display: 'block',
  textAlign: 'right',
});

export const SuspensionRuleLoaderContainer = styled('div')(({ theme }) => ({
  maxWidth: '280px',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '400px',
  },
}));

export const SuspensionRuleLoader = (props) => (
  <ContentLoader height={200} width={400} viewBox="0 0 400 200" {...props}>
    <rect x="15" y="15" rx="4" ry="4" width="130" height="10" />
    <rect x="155" y="15" rx="3" ry="3" width="130" height="10" />
    <rect x="295" y="15" rx="3" ry="3" width="90" height="10" />
    <rect x="15" y="50" rx="3" ry="3" width="90" height="10" />
    <rect x="115" y="50" rx="3" ry="3" width="60" height="10" />
    <rect x="185" y="50" rx="3" ry="3" width="200" height="10" />
    <rect x="15" y="90" rx="3" ry="3" width="130" height="10" />
    <rect x="160" y="90" rx="3" ry="3" width="120" height="10" />
    <rect x="290" y="90" rx="3" ry="3" width="95" height="10" />
    <rect x="15" y="130" rx="3" ry="3" width="130" height="10" />
    <rect x="160" y="130" rx="3" ry="3" width="225" height="10" />
  </ContentLoader>
);
